import styled from "styled-components";

export const WrapDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`;